import PropTypes from "prop-types"

import _ from "lodash"

import React, { useEffect, useState, useMemo, useRef} from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams  } from "react-router-dom"

import { Formik, Field, ErrorMessage, FieldArray, useFormik } from "formik"

import withRouter from "components/Common/withRouter"

import { getSession, setSession } from "helpers/AuthType/authService"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import valadiation Schemas
import { getValidateAccessCodeSchema } from "common/validation-schema"

import {
  applicationResetState,
  applicationValidateAccessCode,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import {
  findElementPositionById,
  regexp,
  showPreloader,
  hidePreloader,
  formatPhoneNumber,
} from "common/global/functions.js"

import ValidateAccessCodeForm from "./forms/validateAccessCodeForm"

const ValidateAccessCode = props => {
  //meta title
  document.title = "Validate Access Code | Equity Sales Finance, INC."

  const dispatch = useDispatch()

  const params =  useParams();

  let {
    app,
    merchant,
    pagetracker,
  } = getSession();


  const applicantType = props.state.applicantType

  var prev_path =
    applicantType == "coapplicant"
      ? "/co/access-code"
      : "/access-code"
      

  const onPreviousBtnClick = path => {
    dispatch(applicationResetState(path, props.router.navigate))
  }

  const [activeTab, setactiveTab] = useState(4)
  let schema = getValidateAccessCodeSchema(applicantType)

  const formRef = useRef()

  const selectApplicationState = state => state.application
  const ApplicationProperties = createSelector(
    selectApplicationState,
    application => ({
      error: application.error,
      loading: application.loading,
      response: application.response,
    })
  )

  const { error,  loading, response, } = useSelector(
    ApplicationProperties
  ) 

  const handleFormSubmit = async () => {
    formRef.current.handleSubmit()
  }

  useEffect(() => {
    if (error) {
      try {
        window.scroll({top: 0,left: 0,behavior: "smooth",})
      } catch (error) {
        window.scrollTo(0, 0)
      }
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={
              applicantType == "coapplicant"
                ? "Co-Signer"
                : "Applicant"
            }
            breadcrumbItem={"Validate Access Code"}
          />
          {error ? <Alert color="danger">{error}</Alert> : null}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Submit Access Code Below:</CardTitle>
                  <div className="wizard clearfix">
                    
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={4}>

                          <Formik
                            enableReinitialize={true}
                            innerRef={formRef}
                            initialValues={
                              schema.initialValues
                            }
                            validationSchema={
                              schema.validationSchema
                            }
                            onSubmit={async values => {
                              try {
                                dispatch(applicationValidateAccessCode(applicantType, values, props.router.navigate))
                              } catch (error) {
                                console.error({ error })
                              }
                            }}                            
                            component = {ValidateAccessCodeForm}
                          />


                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            loading
                              ? "previous disabled"
                              : "previous"
                          }
                        >
                          <Link
                            to={"#"}
                            className="btn btn-info btn-block"
                            onClick={e => {
                              e.preventDefault();
                              onPreviousBtnClick(prev_path)
                            }}
                          >
                            Previous
                          </Link>
                        </li>

                        <li className={loading ? "next disabled" : "next"}>
                          <Link
                            to={"#"}
                            onClick={e => {
                              e.preventDefault()
                              handleFormSubmit()
                            }}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm">Loading...</Spinner>
                                <span> Loading</span>
                              </>
                            ) : (
                              "Next"
                            )}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(ValidateAccessCode)

ValidateAccessCode.propTypes = {
  history: PropTypes.object,
}
